import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClinicOfficeManageService } from 'src/shop-manager/services/clinic-office-manage.service';
import { ClinicOfficeListItem } from 'src/shop-manager/common/models/internal/clinic-office-list-item.model';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ClinicTypesEnum } from 'src/shop-manager/common/enums/clinic-types-enum';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { BrandTypesEnum } from 'src/common-panel/enums/brand-types-enum';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-delete-clinic-office-dialog',
    templateUrl: './delete-clinic-office-dialog.component.html',
    styleUrls: ['./delete-clinic-office-dialog.component.css'],
    standalone: false
})
export class DeleteClinicOfficeDialogComponent
{
  currentClinicOffice: ClinicOfficeListItem | undefined
  // comment:string

  isUs: boolean = false
  isPhysical: boolean = true
  ShopTypesEnum = ShopTypesEnum
  isOffice: boolean = false

  constructor(private _dialog: MatDialog, private dialogRef: MatDialogRef<any>, private serverValueInterpreterService: ServerValueInterpreterService,
    private clinicOfficeManageService: ClinicOfficeManageService)
  {
    this.currentClinicOffice = this.clinicOfficeManageService.currentClinicOffice
    if (this.clinicOfficeManageService.currentClinicOffice?.countryId.toString() == "US") this.isUs = true
    if (this.clinicOfficeManageService.currentClinicOffice?.shopType == ClinicTypesEnum.physical)
    {
      this.isPhysical = true
    } else
    {
      this.isPhysical = false
    }

    if (this.clinicOfficeManageService.currentClinicOffice?.type1 == ShopTypesEnum.entOffice)
    {
      this.isOffice = true
    } else
    {
      this.isOffice = false
    }
  }

  getStateName(state: string): string
  {
    return this.serverValueInterpreterService.getStateName(state);
  }

  exit()
  {
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {
    this.clinicOfficeManageService.deleteClinicOffice()
    this._dialog.closeAll();
  }

  getFullCountryName(countryId?: CountryId): CountriesEnum | string
  {
    if (countryId) return this.serverValueInterpreterService.getFullCountryNameById(countryId)
    return ''
  }

  getFullType1(type1?: ShopTypesEnum): string
  {
    if (type1) return this.serverValueInterpreterService.getFullType1(type1)
    return ''
  }

  getBrandName(brandId: BrandTypesEnum): string
  {
    return this.serverValueInterpreterService.getBrandName(brandId)
  }
}
